module.exports = __webpack_public_path__ + "static/media/alert.d889200f.svg";